import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { SsoOfferCardsResponse } from 'src/apis/storage/types';
import type { OptionalStorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import type { Successful } from 'src/hooks/use-axios';
import { useAxios } from 'src/hooks/use-axios';

type Props = {
  storageServiceRoot: Successful<OptionalStorageServiceRootRequest>;
};

type HookProps = {
  url: string;
};

export function usePublicSsoOfferCards({ storageServiceRoot }: Props) {
  const ssoOfferCards = useAxios(
    (axios, baseConfig, { url }: HookProps) =>
      axios.request<SsoOfferCardsResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    // the link is guaranteed to be present in root response
    const offerCardsLink =
      storageServiceRoot.response.data._links.getSsoOfferCards;

    const templatedUrl = urlTemplate.parse(offerCardsLink.href).expand({});

    ssoOfferCards.execute({ url: templatedUrl });
    // oxlint-disable-next-line exhaustive-deps
  }, [storageServiceRoot.response]);

  return ssoOfferCards;
}

export type PublicSsoOfferCardsRequest = ReturnType<
  typeof usePublicSsoOfferCards
>;
